export enum ApimApttusQueryId {
    GetCustomerQuotes = 'GetCustomerQuotes',
    GetVistaUnicaDataForRinnoviTab = 'GetVistaUnicaDataForRinnoviTab',
    RetrieveClienteCommOrderLineItem = 'RetrieveClienteCommOrderLineItem',
    RetrieveClienteCommProposalLineItem = 'RetrieveClienteCommProposalLineItem',
    RetrieveClienteCommCompletedQuoteWithoutOrder = 'RetrieveClienteCommCompletedQuoteWithoutOrder',
    RetrieveVendAbbinataProposalLineItem = 'RetrieveVendAbbinataProposalLineItem',
    RetrieveVendAbbinataOrderLineItem = 'RetrieveVendAbbinataOrderLineItem',
    RetrieveClienteBroadBandOrderLineItem = 'RetrieveClienteBroadBandOrderLineItem',
    RetrieveClienteBroadBandProposalLineItem = 'RetrieveClienteBroadBandProposalLineItem'
}
